import React, { useEffect, useRef, useState } from "react";
import "@toast-ui/editor/dist/toastui-editor.css";
import { Viewer } from "@toast-ui/react-editor";
import { Box, Stack } from "@mui/material";

const TViewer = (props) => {
  const editorRef = useRef();

  return (
    <Viewer
      // @ts-ignore
      ref={editorRef}
      initialValue={props.chosenSingleBoArticle?.art_content}
      height={"600px"}
    />
  );
};

export default TViewer;
